import { AuditEntityType, UpdateUserRolesDto, UserRolesDto } from '@sr/dto';
import { userApi }                          from 'entities/user/api';
import { invalidateEntityAudit } from 'entities/audit/utils';

const injectedUserApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoles         : builder.query<UserRolesDto[], number>({
      query: (userId: number) => `users/${userId}/roles`,
    }),
    updateRoles: builder.mutation<UpdateUserRolesDto, { userId: number, data: UpdateUserRolesDto }>({
      query: ({ userId, data }) => ({
        url   : `users/${userId}/roles`,
        body  : data,
        method: 'PUT',
      }),
      async onQueryStarted({ userId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.USER, userId);
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const userRoleApi = injectedUserApi.enhanceEndpoints({
  addTagTypes: ['user-roles'],
  endpoints  : {
    getRoles: {
      providesTags: (result, error, query) => result
        ? [{ type: 'user-roles', id: query }]
        : ['user-roles'],
    },
  },
});
